import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAppContext } from '../../context/AppContext.js';
import Button from '../../components/Button.js';
import Title from '../../components/Title.js';
import IconComment from '../../components/icons/IconComment.js';
import BudgetCapitalTopPart5Part1 from './BudgetCapitalTopPart5Part1.js';
import ApiService from '../../services/ApiService.js';
import { getWords } from '../../utils/get-words.js';
import { isValid } from '../../utils/is-valid.js';

const BudgetCapitalTopPart5 = ReactRouterDOM.withRouter(function ({ budgetCapital }) {
  const { i18n, setError } = useAppContext();
  const words = getWords(i18n.code);
  const [path, setPath] = React.useState({});
  const [body, setBody] = React.useState({});
  const [validated, setValidated] = React.useState(false);
  const bodyRef = React.useRef(null);

  React.useEffect(() => {
    load();
  }, []);

  const load = function () {
    const path = {};
    const body = {};
    path.budgetCapitalId = budgetCapital.budgetCapitalId;
    setPath(path);
    setBody(body);
    setValidated(false);
  }
  
  
  const submit = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    if (isValid(bodyRef.current)) {
      try {
        await ApiService.postBudgetCapitalComment(path.budgetCapitalId, body);
      }
      catch (error) {
        setError(error);
        return;
      }
      window.location.reload();
    }
    else {
      setValidated(true);
    }
  }
  
  const updatePath = function (field, value) {
    setPath({ ...path, [field]: value });
  }
  
  const updateBody = function (field, value) {
    setBody({ ...body, [field]: value });
  }
  
  const cancel = async function (e) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    window.location.reload();
  }
  return (
    <div>
      <div>
        <div className="p-1 bg-gray-lighter">
          <Title level={2} icon={IconComment} color="blue" label={words.comments} />
        </div>
        <div className="d-flex align-items-center justify-content-end">
        </div>
        <div ref={bodyRef}>
          <div>
            <BudgetCapitalTopPart5Part1 budgetCapital={budgetCapital} path={path} updatePath={updatePath} body={body} updateBody={updateBody} validated={validated} />
          </div>
        </div>
        <div className="px-1 py-2 d-flex justify-content-end">
          <div>
            <Button label={words.addComment} color="green" onClick={(e) => submit(e)} />
          </div>
          <div className="ps-1">
            <Button label={words.reset} color="blue" onClick={(e) => cancel(e)} />
          </div>
        </div>
      </div>
    </div>
  );
})

export default BudgetCapitalTopPart5;
